import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["InStream"] */ "/app/src/app/_components/ads/InStream.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Leaderboard"] */ "/app/src/app/_components/ads/Leaderboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InStreamAd"] */ "/app/src/app/_components/Article/ads/InStreamAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleSourceButton"] */ "/app/src/app/_components/Article/ArticleHeader/components/GoogleSourceButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/Article/components/ArticleVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleWrapper"] */ "/app/src/app/_components/Article/components/ArticleWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VodVideo"] */ "/app/src/app/_components/Article/components/VodVideo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/AbTest.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/ActionableIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/app/src/app/_components/common/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Icon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/iframe.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Image.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Link.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Logo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/SocialLinksDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthMenu"] */ "/app/src/app/_components/header/AuthMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerMenu"] */ "/app/src/app/_components/header/DrawerMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingProgressBar"] */ "/app/src/app/_components/header/ReadingProgressBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterWrapperWithPaywallAxSpacer"] */ "/app/src/app/_components/Paywall/FooterWrapperWithPaywallAxSpacer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrinityPlayerScript"] */ "/app/src/app/_components/TrinityPlayer/TrinityPlayerScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionItem","AccordionTrigger","AccordionContent","AccordionBase"] */ "/app/src/app/_components/ui/BasicAccordion.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/ui/BasicPopover.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/app/_components/ui/Button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/ui/ButtonV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/app/src/app/_components/ui/Tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionDescription"] */ "/app/src/app/_components/widgets/common/AccordionDescription.tsx");
